import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import FederatedSearchPage from '../../pages/FederatedSearchPage/FederatedSearchPage';
function IpsFederatedSearchModule({ handleSetToastMessage, showGlobalSpinningLoader, title, handleOnSearchError, }) {
    return (React.createElement(GoogleReCaptchaProvider, { reCaptchaKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY },
        React.createElement(FederatedSearchPage, { handleSetToastMessage: handleSetToastMessage, showGlobalSpinningLoader: showGlobalSpinningLoader, handleOnSearchError: handleOnSearchError, title: title })));
}
export default IpsFederatedSearchModule;
